import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class BarcodeType extends BaseDataModel {
	name: string = "";
}
